/* eslint-disable no-param-reassign */

import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  loadCount: 0,
  updateOutboundLegAddressShow: false,
  updateReturnLegAddressShow: false,
  refetchReceipt: false,
};

const uiSlice = createSlice({
  name: 'ui',
  initialState,
  reducers: {
    incrementLoadCount(state) {
      state.loadCount += 1;
    },
    refetchReceipt(state, value = true) {
      state.refetchReceipt = value;
    },
    showInverseLegAddressModal(state, { payload: { direction, value } }) {
      if (direction === undefined) {
        state.updateOutboundLegAddressShow = value;
        state.updateReturnLegAddressShow = value;
      } else {
        state[`update${direction}LegAddressShow`] = value;
      }
    },
  },
});

export const {
  incrementLoadCount,
  showInverseLegAddressModal,
  refetchReceipt,
} = uiSlice.actions;

export default uiSlice.reducer;
